import { InputBase, InputBaseProps } from "@mui/material";
import React, { ForwardedRef, forwardRef, ReactElement } from "react";
import { useNumberInputValue } from "@sinch/components/form/hooks/useNumberInputValue";

export type NumberInputProps = Omit<InputBaseProps, "type"> & {
  /**
   * Allow empty value for number input
   */
  allowEmpty?: boolean;
};

/**
 */
const NumberInput = (
  { error, onChange, value, allowEmpty, ...props }: NumberInputProps,
  ref: ForwardedRef<HTMLDivElement | undefined> | undefined
): ReactElement => {
  const {
    toClosestLimit,
    toNumber,
    localizedValue: numberValue,
  } = useNumberInputValue({
    value: value as number,
    allowEmpty,
    onChange,
    min: props.inputProps?.min,
    max: props.inputProps?.max,
  });

  return (
    <InputBase
      ref={ref}
      error={error}
      {...props}
      onBlur={(e) => {
        props?.onBlur?.(e);
        e.target.value = toClosestLimit(e.target.value);
        onChange?.(e);
      }}
      onChange={(e) => {
        e.target.value = toNumber(e.target.value);
        onChange?.(e);
      }}
      type="text"
      value={numberValue}
    />
  );
};

export const NumberInputBase = forwardRef(NumberInput) as (props: NumberInputProps) => ReturnType<typeof NumberInput>;
